<div class="p-4">
  <h3 class="font-bold mb-4">{{ '::MyClients' | abpLocalization }}</h3>

  <div class="flex flex-col md:flex-row items-center gap-2 mb-4">
    <div class="w-full md:w-80">
      <app-metro-search-input
        [placeholder]="'::SearchByName' | abpLocalization"
        (search)="searchTerm.set($event)"
        (cleared)="searchTerm.set('')">
      </app-metro-search-input>
    </div>
    <div class="w-full md:w-80">
      <app-metro-date-input-picker
        [modeInput]="'range'"
        [placeholder]="'dd/mm/yyyy - dd/mm/yyyy'"
        [startDateInput]="dateRange.start"
        [endDateInput]="dateRange.end"
        (rangeSelectedChange)="onDateRangeChange($event)">
      </app-metro-date-input-picker>
    </div>
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center py-8">
      <p class="text-gray-500">{{ '::Loading' | abpLocalization }}...</p>
    </div>
  } @else {
    @if (filteredClients().length > 0) {
      <div class="space-y-3">
        @for (client of filteredClients(); track client.userId) {
        <div
          (click)="goToClientDetail(client.userId)"
          class="bg-white rounded-xl p-2 border border-gray-200 hover:shadow-md transition-shadow cursor-pointer">
          <div class="flex flex-row items-center justify-between gap-4">
            <!-- Información del cliente -->
            <div class="flex flex-col gap-1">
              <div class="flex items-center gap-1 text-base">
                <span class="text-metro-black font-semibold leading-none">
                  {{ client.clientName | titlecase }} {{ client.clientSurname | titlecase}}
                </span>
                <a *ngIf="client.whatsAppHref"
                  [href]="client.whatsAppHref"
                  class="rounded-full border border-green-200 bg-white text-green-600 hover:bg-green-50 transition"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp">
                  <span [innerHTML]="safeWhatsAppIcon" class="text-current"></span>
                </a>
              </div>
              <span class="text-metro-blue text-sm">
                {{ '::LastPurchase' | abpLocalization }}: {{ formatDate(client.lastPurchaseDate) }}
              </span>
            </div>

            <!-- Total comprado -->
            <div class="flex flex-col items-end gap-1">
              <span class="text-metro-blue-secondary font-bold text-lg">
                {{ formatCurrency(client.totalPurchases) }}
              </span>
              <span class="text-xs text-gray-500">
                {{ '::TotalPurchases' | abpLocalization }}
              </span>
            </div>
          </div>
        </div>
        }
      </div>
    } @else {
      <div class="rounded-lg border border-gray-200 p-8 text-center text-gray-500">
        <p>{{ '::NoClientsFound' | abpLocalization }}</p>
      </div>
    }
  }
</div>


